import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'
import data from '@/components/Feature/Rankings/Data'
import Ranking from '@/components/Feature/Rankings/Ranking'
import TitleSelector from '@/components/Feature/Rankings/TitleSelector'
import { CalidadDeLaInvestigacion } from '@/components/Feature/Rankings/Output'
import PdfRenderer from '@/components/Feature/Rankings/pdf'

const IndexPage = () => {
  const rankings = data.filter(item => item.name === 'Rankings')[0].rankings
  const datalocal = rankings.find(
    item =>
      item.link ===
      '/rankings-generales/percepcion-de-calidad-de-la-investigacion/',
  )

  return (
    <Layout>
      <SEO
        title={datalocal.name}
        keywords={[
          `La Tercera`,
          `${datalocal.name}`,
          `Ranking de Universidades Chilenas 2022`,
        ]}
      />
      <Content>
        <TitleSelector
          pretitle="Ranking de Universidades 2022"
          allRankings={rankings}
          section="rankings-generales"
          sectionSlug={datalocal.slug}
        />
        <Columns
          dangerouslySetInnerHTML={{ __html: datalocal.content }}></Columns>
        <Ranking ranking={datalocal.ranking} />

        <PdfRenderer url={datalocal.pdflink} />
        <Summary />
      </Content>
    </Layout>
  )
}

export default IndexPage
